export default __webpack_public_path__ + "static/media/gucci_x_mad_1_lowdef.8e282cbd.png";